<template>
  <div class="row pg_sec">
    <div class="col-12 sec_content">
      <div class="row">
        <div class="col-12 gph_sec ace_sec" aria-label="Chart">
          <div class="bar_chart_container bar_label_inside chart_age_breakdown">
            <template v-for="(item, index) in data">
              <div class="row bar_row ace_sec">
                <div class="col-12">

                  <div class="bar_container clickable" :id="'popover_' + index">
                     <div class="bar_label">{{ item.name }} </div>
                     <div class="bar_val"><span v-html="formatDecimalValue(item.growthDoubleFormat)"></span>% </div>
                     <div class="bar" v-bind:style="{width:item.growthDoubleFormat + '%'}"></div>
                  </div>

                  <div id="chartToolTip" class="chart_tooltip_popover"></div>

                  <b-popover :target="'popover_' + index" triggers="hover focus" placement="top" class="chart_tooltip_popover" container="chartToolTip">
                    <div class="tooltip_row">
                      <div class="val">{{ item.name }}</div>
                    </div>
                    <div class="tooltip_row">
                      <div class="label">Growth Rate</div>
                      <div class="val"><span v-html="formatDecimalValue(item.growthDoubleFormat)"></span>% </div>
                    </div>
                  </b-popover>

                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'fastestGrowingCareersList',
  props: ['title', 'data'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadList()
  },

  methods: {
    loadList () {
    },
    navigateToCareer (career) {
      if (!career.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      let routerParams = {
        code: career.code,
        returnTo: 'exploreCareerResults',
        showBackToResultButton: true
      }
      return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'exploreInsightList'} })
    },
    formatDecimalValue (numValue) {
      return parseFloat(numValue).toFixed(2)
    }
  }
}
</script>

<style scoped>
  .bar_chart_container .bar_row {
    margin: 14px 0;
  }

  .bar_row:first-child {
    margin-top: 0;
  }

  .bar_chart_container .bar_row .bar_container {
    position: relative;
    background: #f5f5f5;
    height: 35px;
    padding-left: 0;
  }

  .bar_chart_container .bar_row .bar_container.clickable {
    cursor: pointer;
  }

  .bar_label_inside .bar_container .bar_label {
    font-size: 18x;
    color: #323232;
    left: 15px;
    top: -1px;
    text-align: left;
    position: absolute;
    z-index: 1;
  }

  .bar_chart_container .bar_row .bar_label {
    font-size: 18x;
    color: #323232;
    padding-right: 20px;
    padding-top: 7px;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 110px);
    display: inline-block;
    text-transform: capitalize;
  }

  .bar_chart_container .bar_row .bar_container .bar_val {
    font-size: 18x;
    color: #323232;
    position: absolute;
    right: 15px;
    top: 5px;
    z-index: 1;
  }

  .bar_chart_container .bar_row .bar_container .bar {
    min-width: 5px;
    position: absolute;
    height: 35px;
    background: #c8c8c8;
    z-index: 0;
  }

  .bar_chart_container .bar_row:first-child .bar {
    background: #ff6384;
  }

  .bar_chart_container .bar_row:nth-child(2) .bar {
    background: #36a2eb;
  }

  .bar_chart_container .bar_row:nth-child(3) .bar {
    background: #ffce56;
  }

  .bar_chart_container .bar_row:nth-child(4) .bar {
    background: #f58231;
  }

  .bar_chart_container .bar_row:nth-child(5) .bar {
    background: #46f0f0;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/FastestGrowingCareersList.vue